module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image33.20bf551d.jpg";